import React from 'react';
import { Link } from 'react-router-dom';
import { Button, ButtonProps } from '../../mui-builder/Button/Button';
import useFieldHelper from '../../field/fieldHelper';
import { getVisibility } from 'framework/utils';
import { useUiTheme } from 'framework/uiTheme';

export interface LinkButtonProps extends ButtonProps {
  children?: React.ReactNode | React.ReactNode[];
  url: string | ((id?: Nullable<StringOrNumber>) => string);
  target?: string;
  permissionToCheck?: string | string[];
  source?: string;
  isVisible?: boolean | ((data: any) => boolean);
}

const LinkButton = ({ children, url: initialUrl, isVisible = true, ...otherProps }: LinkButtonProps) => {
  const props: any = {
    value: '',
    ...otherProps,
  };
  const { key, ...filteredOther } = props;
  const { getValue } = useFieldHelper(props);
  let url = initialUrl;
  const { Button: ThemedButton = Button } = useUiTheme();

  const { getData } = useFieldHelper();
  const data = getData();

  const isButtonVisible = getVisibility(data, isVisible);

  if (!isButtonVisible) {
    return null;
  }

  if (typeof initialUrl === 'function') {
    url = initialUrl(getValue());
  }

  return (
    <ThemedButton key={key} component={Link} to={url} {...filteredOther}>
      {children}
    </ThemedButton>
  );
};

export default LinkButton;
